define("calendar/components/calendar/settings/bttp/upgrade", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="u--text--success" data-test-id="bttp-upgrade">
    {{svg-jar "verified" class="o--icon o--icon--success u--m__r__xs"}}
    {{t "bttp.eligible"}}
  </p>
  
  <p class="u--text--light">
    {{html-safe (t "bttp.toggle_details_legacy")}}
  </p>
  
  <Shared::Ui::Button @onClick={{perform @triggerBttp true}} @type={{"outline"}}>
    {{svg-jar "bttp" class="o--icon u--m__r__xs"}}
    {{t "bttp.generate"}}
  </Shared::Ui::Button>
  
  <Shared::CollapsableInfoCard @title={{t "bttp.improved_feature"}}>
    <ul>
      <li>{{t "bttp.no_minimum_posts"}}</li>
      <li>{{t "bttp.more_accurate_timeslots"}}</li>
    </ul>
  </Shared::CollapsableInfoCard>
  
  */
  {
    "id": "JfLVqg4h",
    "block": "[[[10,2],[14,0,\"u--text--success\"],[14,\"data-test-id\",\"bttp-upgrade\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"verified\"],[[\"class\"],[\"o--icon o--icon--success u--m__r__xs\"]]]],[1,\"\\n  \"],[1,[28,[35,1],[\"bttp.eligible\"],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,2],[14,0,\"u--text--light\"],[12],[1,\"\\n  \"],[1,[28,[35,2],[[28,[37,1],[\"bttp.toggle_details_legacy\"],null]],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,3],null,[[\"@onClick\",\"@type\"],[[28,[37,4],[[30,1],true],null],\"outline\"]],[[\"default\"],[[[[1,\"\\n  \"],[1,[28,[35,0],[\"bttp\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n  \"],[1,[28,[35,1],[\"bttp.generate\"],null]],[1,\"\\n\"]],[]]]]],[1,\"\\n\\n\"],[8,[39,5],null,[[\"@title\"],[[28,[37,1],[\"bttp.improved_feature\"],null]]],[[\"default\"],[[[[1,\"\\n  \"],[10,\"ul\"],[12],[1,\"\\n    \"],[10,\"li\"],[12],[1,[28,[35,1],[\"bttp.no_minimum_posts\"],null]],[13],[1,\"\\n    \"],[10,\"li\"],[12],[1,[28,[35,1],[\"bttp.more_accurate_timeslots\"],null]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]]],[1,\"\\n\"]],[\"@triggerBttp\"],false,[\"svg-jar\",\"t\",\"html-safe\",\"shared/ui/button\",\"perform\",\"shared/collapsable-info-card\"]]",
    "moduleName": "calendar/components/calendar/settings/bttp/upgrade.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});